import { Reveal, Eyebrow } from "./Reveal";

const isOpenNow = () => {
  const now = new Date();
  const day = now.getDay();
  const mins = now.getHours() * 60 + now.getMinutes();
  return day >= 1 && day <= 5 && mins >= 19 * 60 && mins < 21 * 60 + 30;
};

const rows = [
  { days: "Lunedì — Venerdì", hours: "19:00 – 21:30", note: "Solo la sera" },
  { days: "Sabato — Domenica", hours: "Chiuso", note: "Riposo settimanale" },
];

const Orari = () => {
  const open = isOpenNow();
  return (
    <section id="orari" className="py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>Orari di apertura</Eyebrow>
              <h2 className="mt-6 font-serif-display font-medium text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight" data-testid="orari-title">
                Solo la sera, <em className="text-[#7A1C28]">come si deve.</em>
              </h2>
              <p className="mt-6 max-w-sm text-base leading-relaxed text-[#6E6A66] font-light">
                Apriamo quando la giornata rallenta: cinque sere a settimana, dal lunedì al venerdì.
              </p>
            </Reveal>
            <Reveal delay={0.15} className="mt-8">
              <span
                data-testid="open-status-badge"
                className={`inline-flex items-center gap-2.5 rounded-full px-5 py-2.5 font-mono-accent text-xs uppercase tracking-[0.2em] border ${
                  open
                    ? "border-[#D99B26]/50 text-[#B87F1B] bg-[#D99B26]/10"
                    : "border-[#1C1917]/15 text-[#6E6A66]"
                }`}
              >
                <span className={`h-2 w-2 rounded-full ${open ? "bg-[#D99B26] animate-pulse" : "bg-[#6E6A66]/50"}`} />
                {open ? "Aperto ora" : "Chiuso ora"}
              </span>
            </Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex flex-col justify-center">
            {rows.map((r, i) => (
              <Reveal key={r.days} delay={i * 0.12}>
                <div
                  className="flex flex-wrap items-baseline justify-between gap-3 border-t border-[#E7E4DF] py-8 last:border-b"
                  data-testid={`orari-row-${i}`}
                >
                  <span className="font-serif-display text-xl sm:text-2xl">{r.days}</span>
                  <div className="text-right">
                    <span className={`font-mono-accent text-lg sm:text-xl ${r.hours === "Chiuso" ? "text-[#7A1C28]" : "text-[#1C1917]"}`}>
                      {r.hours}
                    </span>
                    <p className="mt-1 font-mono-accent text-[11px] uppercase tracking-[0.2em] text-[#6E6A66]">{r.note}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Orari;
